import { render, staticRenderFns } from "./EditorDivisions.vue?vue&type=template&id=0b21bd0c&scoped=true"
import script from "./EditorDivisions.vue?vue&type=script&lang=js"
export * from "./EditorDivisions.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0b21bd0c",
  null
  
)

export default component.exports